var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},[_c('vi-alert',{staticClass:"promotion-ios14-switch-alert",attrs:{"data-testid":"encourage-info-index-8vJQ4H","closable":false,"title":_vm.$t('module_ios14_encourage_dc'),"type":"info","show-icon":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }